import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, Text, Icon, useTheme } from '@Sage/hoi-poi-ui';
import SetupStatusIcon from '../components/SetupStatusIcon';

const CampaignSection = memo(
    ({
        isCompleted = false,
        title,
        subtitle = null,
        actionLabel,
        isExpanded = false,
        onToggle,
        hideStatusIcon = false,
        isDimmed = false,
        children = null,
    }) => {
        const theme = useTheme();
        const renderSubtitle = () => {
            if (!subtitle) return null;

            if (typeof subtitle === 'string') {
                return (
                    <Text type="body" className="campaign-details__section-subtitle">
                        {subtitle}
                    </Text>
                );
            }

            return subtitle;
        };

        const sectionClassName = `campaign-details__section ${
            isDimmed ? 'campaign-details__section--dimmed' : ''
        } ${isExpanded ? 'campaign-details__section--expanded' : ''}`;

        return (
            <div className={sectionClassName}>
                <div className="campaign-details__section-main-row">
                    {!hideStatusIcon && (
                        <div className="campaign-details__section-icon">
                            <SetupStatusIcon isCompleted={isCompleted} />
                        </div>
                    )}
                    <div className="campaign-details__section-content">
                        <Text type="h6" className="campaign-details__section-title">
                            {title}
                        </Text>
                        {renderSubtitle()}
                    </div>
                    <div className="campaign-details__section-action">
                        <>
                            {isExpanded ? (
                                <Icon
                                    color={theme.colors.grey[500]}
                                    name="close"
                                    onClick={onToggle}
                                />
                            ) : (
                                <Button
                                    type="secondary"
                                    size="small"
                                    onClick={onToggle}
                                    disabled={isDimmed}
                                >
                                    {actionLabel}
                                </Button>
                            )}
                        </>
                    </div>
                </div>
                {isExpanded && (
                    <div className="campaign-details__section-expanded-content">{children}</div>
                )}
            </div>
        );
    },
);

CampaignSection.displayName = 'CampaignSection';

CampaignSection.propTypes = {
    isCompleted: PropTypes.bool,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.node,
    actionLabel: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    hideStatusIcon: PropTypes.bool,
    isDimmed: PropTypes.bool,
    children: PropTypes.node,
};

export default CampaignSection;
